import React from 'react'
import { Modal } from 'uiComponents/popups/modal.new'
import { DiscountCodeForm, discountCodeFormatter } from '../_shared'
import { useGetDiscountCodeDetailsQuery } from 'discounts/reduxQuery'
import { removeHash } from 'utils/hash'
import { DiscountCodeFormSchema } from '../_shared'
import { showSuccessMessage } from 'uiComponents/message'
import '../_shared/modal.scss'

interface editDiscountModalProps {
    codeUuid: string
    poolUuid: string
    accountSlug: string
}

export const EditDiscountModal = ({ codeUuid, poolUuid, accountSlug }: editDiscountModalProps) => {
    const { data: discount } = useGetDiscountCodeDetailsQuery({ accountSlug, poolUuid, codeUuid })
    const formattedDiscount = discountCodeFormatter.toForm(discount)

    const afterSubmit = (discount: DiscountCodeFormSchema) => {
        removeHash()
        showSuccessMessage(`Discount "${discount.code}" updated successfully`)
    }

    return discount ? (
        <Modal onDismiss={removeHash} title={`Edit ${formattedDiscount.type} discount`} className="edit-discount-modal">
            <DiscountCodeForm
                discount={formattedDiscount}
                discountType={formattedDiscount.type}
                onCancel={removeHash}
                afterSubmit={afterSubmit}
            />
        </Modal>
    ) : null
}
